<div>
  <br>
  <div>
    <span class="fw-extrabold fs-4">Confirmación del registro</span>
  </div>
  <div class="my-3">
    <span class="fs-6 fw-regular">Confirma el registro de este producto a tu cliente.</span>
  </div>
  <br><br><br><br>
  <div class="my-3 content-confirm text-center">
    <span class="fs-6 fw-regular fs-4">Al confirmar este producto se enviara este formulario a la 
      base de datos de Kaizen y en un plazo máximo de 48 horas se estará actualizando 
      en tu base de clientes. Clic en <strong>Registrar producto</strong> para finalizar.</span>
  </div>
</div>